<template>
  <div class="home">
    <banner></banner>
    <flexible-investment v-if="!$config.needElectronicContract"></flexible-investment>
    <fixed-investment></fixed-investment>
    <trust></trust>
    <products></products>
    <investors></investors>
    <media></media>
    <footer-bar></footer-bar>
    <activity-popup></activity-popup>
  </div>
</template>

<script>
import Banner from '@/components/home/Banner'
import FlexibleInvestment from '@/components/home/FlexibleInvestment'
import FixedInvestment from '@/components/home/FixedInvestment'
import Trust from '@/components/home/Trust'
import Products from '@/components/home/Products'
import Investors from '@/components/home/Investors'
import Borrowers from '@/components/home/Borrowers'
import Media from '@/components/home/Media'
import FooterBar from '@/components/home/FooterBar'
import ActivityPopup from '@/components/common/dialog/ActivityPopup'

const Cookie = require('js-cookie')

export default {
  components: {
    FixedInvestment,
    Banner,
    FlexibleInvestment,
    Borrowers,
    Trust,
    Products,
    Investors,
    Media,
    FooterBar,
    ActivityPopup,
  },
  mounted() {
    const { channel } = this.$route.query
    if (channel) {
      Cookie.set('channel', channel)
    }
    this.initZenDesk()
  },
  methods: {
    initZenDesk() {
      const snapScript = document.createElement('script')
      const snapId = 'ze-snippet'
      const snapSrc = 'https://static.zdassets.com/ekr/snippet.js?key=4e0b1e0b-1f15-4caf-99c1-17b6c6336400'
      snapScript.setAttribute('id', snapId)
      snapScript.setAttribute('src', snapSrc)
      document.head.appendChild(snapScript)
    },
  },
}
</script>

<style scoped lang="stylus">
.home {
}
</style>
